import AccountNavigationFragment from './AccountNavigationFragment';
import AccountSettingsFragment from './AccountSettingsFragment';
import AppSettingsFragment from './AppSettingsFragment';
import BreedsFrag from './BreedsFragment';
import ChannelFrag from './ChannelFragment';
import KeyRecordContextFragment from './KeyRecordContextFragment';
import PrivacyPolicyFragment from './PrivacyPolicyFragment';
import SocialMediaFragment from './SocialMediaFragment';
import TermsOfUseFragment from './TermsOfUseFragment';
export default `
	fragment ContentFragment on Content {
		... on Breeds {
			...BreedsFragment
		}
		... on Channel {
			...ChannelFrag
		}
		... on Microsites {
			id
			title
			body
			linkMicroTitle
			enabled
			links
			createdDate
			updatedDate
		}
		... on Scancode {
			id
			title
			image
			channel
			key
			path
			createdDate
			updatedDate
		}
		... on KeyRecordContext {
			...KeyRecordContextFragment
		}
		... on Recipes {
			id
			title
			description
			sku
			qrCode
			createdDate
			updatedDate
		}
		... on CustomerReviews {
			id
			title
			createdDate
			updatedDate
		}
		... on AdminNavigation {
			id
			title
			url
			icon
			sequence
			enabled
			createdDate
			updatedDate
		}
		... on AccountNavigation {
			...AccountNavigationFragment
		}
		... on Quicklinks {
			id
			title
			url
			enabled
			createdDate
			updatedDate
		}
		... on CompetitiveChart {
			id
			title
			enabled
			basicKibble
			premiumKibble
			homeMade
			competition
			createdDate
			updatedDate
		}
		... on Hero {
			id
			title
			subtitle
			backgroundImage
			enabled
			createdDate
			updatedDate
		}
		... on ContentBlock {
			id
			title
			subtitle
			text
			media
			styles
			links
			enabled
			createdDate
			updatedDate
		}
		... on ContentBlockCollection {
			id
			title
			items
			enabled
			createdDate
			updatedDate
		}
		... on ActivityLevel {
			id
			title
			description
			image
			value
			enabled
			createdDate
			updatedDate
		}
		... on PrivacyPolicy {
			...PrivacyPolicyFragment
		}
		... on TermsOfUse {
			...TermsOfUseFragment
		}
		... on SocialMedia {
			...SocialMediaFragment
		}
		... on AppSettings {
			...AppSettingsFragment
		}
		... on AccountSettings {
			...AccountSettingsFragment
		}
	}
	${BreedsFrag}
	${ChannelFrag}
	${KeyRecordContextFragment}
	${PrivacyPolicyFragment}
	${TermsOfUseFragment}
	${SocialMediaFragment}
	${AppSettingsFragment}
	${AccountNavigationFragment}
	${AccountSettingsFragment}
`;
